import { ChangePartner } from './ChangePartner';

export class ChangePartnerAlt extends ChangePartner {
  type: string = 'Partner.ChangeAltText';
}
